export default __webpack_public_path__ + "static/media/questionnaire_review_icon.390051e6.svg";